import { view } from '@yola/ws-sdk';

const scrollToPosition = (scrollPosition) =>
  view.helpers.smoothScroll.scrollToPosition(scrollPosition);

export default scrollToPosition;
